import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
//image
// import SlowImg1 from '../../assets/img/route-29-slow-img1.png';
import SlowImg1 from '../../assets/img/route-28-slow-img1.png';
// import SlowImg1Eng from '../../assets/img/route-29-slow-img1-eng.png';
import SlowImg1Eng from '../../assets/img/route-28-slow-img1-eng.png';

const Slow = ({language}) => {
    return (
        <section className="route29-slow">
            <h5><span>{language === "Chinese" ? "坡度圖" : "Elevation Profile"}</span></h5>
            <Container>
                <Row className='align-items-center'>
                    <Col className='mt-5 mb-5'>
                        {language === 'Chinese' ? <img src={SlowImg1} alt="坡度圖" /> : <img src={SlowImg1Eng} alt="Elevation profile" />}
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Slow